import { path, httpService } from '@commons';

/////////////////////////////////////////////////////////////////////////////////
const args = { ...path, path: '/pecuaria/cadastro/lote' };
/////////////////////////////////////////////////////////////////////////////////

export function createAnimalLoteCadastro(payload) {
  return httpService.post(args, payload);
}

export function updateAnimalLoteCadastro(payload) {
  const { id } = payload

  return httpService.put({ ...args, args: `/${id}` }, payload);
}

export function listAnimalLoteCadastro(param) {
  return httpService.get({...args, args: param});
}

export function findAnimalLoteCadastro(id) {
  return httpService.get({ ...args, args: `/${id}` });
}

export function deleteAnimalLoteCadastro(id) {
  return httpService.del({ ...args, args: `/${id}` });
}

